import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { checkValue } from 'src/components/common/helper';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import FeatureStayModule from 'src/components/common/modules/v1/standard-hotel-partner-module/feature-stay-module';
import StandardPartnerModule from 'src/components/common/modules/v1/standard-hotel-partner-module/standard-partner-module';

const StandardHotelPartnerModule = (props: ModuleProps) => {
  const { data, mccidData } = props;  
  if (checkValue(data)) {
    if (data.hotelPartnerType === 'Premium') {
      const componentLayoutType: ComponentLayoutType<any> = {
        moduleName: 'featureStayModule',
        data: { ...data, ...{mccidData:mccidData} },
      };
     
      return (
        <>
          <FeatureStayModule {...componentLayoutType} />
        </>
      );
    } else {
      const componentLayoutType: ComponentLayoutType<any> = {
        moduleName: 'standardHotelPartnerModule',
        data: { ...data, ...{mccidData:mccidData} },
      };
     
      return (
        <>
          <StandardPartnerModule {...componentLayoutType} />
        </>
      );
    }
  }
};

export { StandardHotelPartnerModule };
